import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaUsers, FaChalkboardTeacher, FaRunning, FaCalendarAlt } from 'react-icons/fa';
import axios from 'axios';
import Concert from '../../Photos/Concert.png';
import JdS from '../../Photos/JdS.png';
import CardProjet from '../Clubs/cardProjet';
import './i18n'; // Importer la configuration i18n

function Accueil() {
  const [projets, setProjets] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    // Fonction pour récupérer trois projets aléatoires
    const fetchRandomProjects = async () => {
      try {
        const response = await axios.get('https://www.clublfit.org/api/projets/aleatoire');
        const projectsWithImages = response.data.map((project) => {
          if (project.Url_IMG_Projet) {
            return { ...project, imageUrl: project.Url_IMG_Projet };
          } else if (project.Photo_Projet && project.Photo_Projet.data) {
            const blob = new Blob([new Uint8Array(project.Photo_Projet.data)], { type: 'image/png' });
            const imageUrl = URL.createObjectURL(blob);
            return { ...project, imageUrl };
          } else {
            console.warn(`Aucune image disponible pour le projet ID: ${project.Id_Projet}`);
            return { ...project, imageUrl: null };
          }
        });
        

        setProjets(projectsWithImages);
      } catch (error) {
        console.error('Erreur lors de la récupération des projets :', error);
      }
    };

    fetchRandomProjects();
  }, []);

  return (
    <div className="container my-5">
      {/* Section d'introduction */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 mb-4">{t('welcome')}</h1>
          <p className="lead">{t('introduction')}</p>
        </div>
      </div>

      <hr className="my-5" />

      {/* Pourquoi rejoindre un club */}
      <div className="row align-items-center mt-5">
        <div className="col-md-6 order-md-2 text-center">
          <img
            src={Concert}
            alt="Clubs"
            className="img-fluid rounded"
            style={{ width: '500px', height: '500px', objectFit: 'cover' }}
          />
        </div>
        <div className="col-md-6 order-md-1">
          <h2 className="mb-4">{t('why_join_club')}</h2>
          <ul className="list-unstyled">
            <li className="mb-3">
              <FaUsers className="text-primary me-2" />
              <strong>{t('develop_skills')}</strong>
            </li>
            <li className="mb-3">
              <FaChalkboardTeacher className="text-primary me-2" />
              <strong>{t('explore_interests')}</strong>
            </li>
            <li className="mb-3">
              <FaRunning className="text-primary me-2" />
              <strong>{t('create_memories')}</strong>
            </li>
          </ul>
        </div>
      </div>

      <hr className="my-5" />

      {/* Comment rejoindre un club */}
      <div className="row mt-5">
        <div className="col-12 text-center">
          <h2 className="mb-4">{t('join_or_create')}</h2>
        </div>
        <div className="col-md-4 text-center">
          <FaUsers size={50} className="text-primary mb-3" />
          <h5>{t('form_team')}</h5>
          <p>{t('form_team_description')}</p>
        </div>
        <div className="col-md-4 text-center">
          <FaChalkboardTeacher size={50} className="text-primary mb-3" />
          <h5>{t('define_goals')}</h5>
          <p>{t('define_goals_description')}</p>
        </div>
        <div className="col-md-4 text-center">
          <FaCalendarAlt size={50} className="text-primary mb-3" />
          <h5>{t('submit_request')}</h5>
          <p>{t('submit_request_description')}</p>
        </div>
      </div>

      <hr className="my-5" />

      {/* Responsabilités des clubs */}
      <div className="row align-items-center mt-5">
        <div className="col-md-6 text-center">
          <img
            src={JdS}
            alt="Responsabilités des clubs"
            className="img-fluid rounded"
            style={{ width: '500px', height: '500px', objectFit: 'cover' }}
          />
        </div>
        <div className="col-md-6">
          <h2 className="mb-4">{t('responsibilities')}</h2>
          <p>{t('responsibilities_description')}</p>
        </div>
      </div>

      <hr className="my-5" />

      {/* Projets des clubs */}
      <div className="row mt-5">
        <div className="col-12 text-center">
          <h2 className="mb-4">{t('projects_highlight')}</h2>
          <div className="d-flex flex-wrap justify-content-center">
            {projets.length > 0 ? (
              <CardProjet projects={projets.slice(0, 3)} />
            ) : (
              <p>{t('loading')}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Accueil;
